import React from 'react';
import { cn } from '../../lib/utils';

export type NotificationDotProps = {
  count?: number;
  variant?: 'brand' | 'danger' | 'success' | 'warning';
  show?: boolean;
  children: React.ReactNode;
  className?: string;
};

const VARIANT_CLASSES: Record<NonNullable<NotificationDotProps['variant']>, string> = {
  brand: 'bg-brand',
  danger: 'bg-status-error',
  success: 'bg-status-success',
  warning: 'bg-status-warning',
};

const NotificationDot = React.forwardRef<HTMLDivElement, NotificationDotProps>(
  (
    {
      count,
      variant = 'brand',
      show = true,
      children,
      className,
    },
    ref,
  ) => {
    const hasCount = typeof count === 'number' && count > 0;
    const shouldShow = show && (hasCount || (count === undefined && show));

    return (
      <div ref={ref} className={cn('relative inline-flex', className)}>
        {children}
        {shouldShow && (
          <span
            className={cn(
              'absolute -top-1 -right-1 flex items-center justify-center rounded-full border-2 border-surface-page',
              VARIANT_CLASSES[variant],
              hasCount
                ? 'min-w-[18px] h-[18px] text-[10px] font-medium text-white px-1'
                : 'w-2.5 h-2.5',
            )}
          >
            {hasCount ? (count! > 99 ? '99+' : count) : null}
          </span>
        )}
      </div>
    );
  },
);

NotificationDot.displayName = 'NotificationDot';

export default NotificationDot;
